import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import PermissionHOC from 'src/hoc/PermissionHOC';
import UpsertButton from '../UpsertButton';

const FormikCreateSearchClear = ({
    isSubmitting,
    isUpdate,
    onSearch,
    onClear,
    resetForm,
    values,
    submitButtonText,
    canClear,
    submitScope,
    searchScope,
}) => (
    <>
        {/* CREATE UPDATE */}
        <PermissionHOC
            scope={submitScope}
        >
            <UpsertButton
                type="submit"
                disabled={isSubmitting}
                isUpdate={isUpdate}
                submitButtonText={submitButtonText}
            />
        </PermissionHOC>

        {/* SEARCH */}
        <PermissionHOC
            scope={searchScope}
        >
            <button
                onClick={() => {
                    onSearch(values);
                }}
                type="button"
                className={classNames('btn btn-light ml-3', {
                    'd-none': !onSearch,
                })}
            >
                Search
            </button>
        </PermissionHOC>

        {/* CLEAR */}
        {canClear ? (
            <button
                onClick={(e) => {
                    onClear(e);
                    resetForm();
                }}
                type="button"
                className="btn btn-link ml-3"
            >
                Clear
            </button>
        ) : null}
    </>
);

FormikCreateSearchClear.propTypes = {
    isSubmitting: PropTypes.bool.isRequired,
    onClear: PropTypes.func,
    resetForm: PropTypes.func.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    values: PropTypes.any,
    isUpdate: PropTypes.bool,
    onSearch: PropTypes.func,
    submitButtonText: PropTypes.string,
    canClear: PropTypes.bool,
    submitScope: PropTypes.string,
    searchScope: PropTypes.string,
};

FormikCreateSearchClear.defaultProps = {
    values: null,
    isUpdate: false,
    onSearch: null,
    onClear: () => { },
    submitButtonText: 'Submit',
    canClear: true,
    submitScope: '',
    searchScope: '',
};

export default FormikCreateSearchClear;
